'use client';

import { createContext, JSX, PropsWithChildren, useContext } from 'react';

export interface StatsigExperimentContextValue {
    isSearchHistoryEnabled: boolean;
    showConversationalSearchCta: boolean;
    showConversationalSearchAudio: boolean;
    showConversationalSearchImages: boolean;
    conversationalAnimatedToggleEnabled: boolean;
    /** Members get auto-on-hover; visitors keep the mount-time glow instead. */
    autoOnHoverEnabled: boolean;
}

const StatsigExperimentContext = createContext<StatsigExperimentContextValue>({
    isSearchHistoryEnabled: false,
    showConversationalSearchCta: false,
    showConversationalSearchAudio: false,
    showConversationalSearchImages: false,
    conversationalAnimatedToggleEnabled: false,
    autoOnHoverEnabled: false,
});

export function useStatsigExperimentContext(): StatsigExperimentContextValue {
    return useContext(StatsigExperimentContext);
}

// React Context can only be provided from a Client Component.
// This means that the server-side StatsigExperimentContextProvider cannot invoke StatsigExperimentContext.Provider directly
export function StatsigExperimentContextProvider({
    children,
    ...flags
}: PropsWithChildren<StatsigExperimentContextValue>): JSX.Element {
    return <StatsigExperimentContext.Provider value={flags}>{children}</StatsigExperimentContext.Provider>;
}
